import { FC } from 'react';
import { GroupBase, OptionProps } from 'react-select';
import HTMLReactParser from 'html-react-parser';
import cx from 'classnames';

import { SelectOption } from '../models';

import styles from './OptionExtendChain.module.sass';

export type OptionExtendChainProps = OptionProps<
  SelectOption,
  false,
  GroupBase<SelectOption>
>;

const OptionExtendChain: FC<OptionExtendChainProps> = (props) => {
  const { innerProps, data } = props;
  const { label, value, description } = data;

  const isSelected = true;

  const classes = cx(styles.option, {
    'is-selected': isSelected,
  });

  return (
    <div className={classes} {...innerProps}>
      <div className={styles.option__label}>{label}</div>
      <div className={styles.option__description}>
        {HTMLReactParser(description || '')}
      </div>
    </div>
  );
};

export default OptionExtendChain;
